export const BASE_URL = "https://fso-admin.amplitudo.me";
export const API_URL = BASE_URL + "/api/";
